import React, { useRef, useState, useEffect } from "react";
import classes from "./messageInput.module.css";
import { IoSend } from "react-icons/io5";
import { getScenarios } from "../../API"; // ONLY using getScenarios
import SelectDropdown from "../../ui/forms/SelectDropdown";

// Add customerId to props
export default function MessageInput({ onSendMessage, loading, customerId }) { 
  const [message, setMessage] = useState("");
  const [scenarios, setScenarios] = useState([]);
  const [selectedScenario, setSelectedScenario] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    fetchScenariosList(); // Renamed function for clarity
  }, []);

  // Function to fetch the list of scenarios (called on mount)
  const fetchScenariosList = async () => { 
    setIsLoading(true);
    try {
      // Call getScenarios without parameters to get the list
      const response = await getScenarios(); 
      if (response && response.status && response.data) {
        setScenarios(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch scenarios list:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const onSend = () => {
    if (!message) return;
    // Pass scenario_id (stored in selectedScenario) to onSendMessage
    onSendMessage({ msg: message, file: null, scenario_id: selectedScenario });
    setMessage("");
    setSelectedScenario("");

    // Focus the textarea after sending
    inputRef.current.focus();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  // MODIFICATION: Logic to call getScenarios with parameters for detail
  const handleSelectScenario = async (value) => { 
    if (!value || !customerId) return;
    
    // Check if the selected item is the placeholder/empty option
    if (value === "") {
        setMessage("");
        setSelectedScenario("");
        inputRef.current.focus();
        return;
    }

    setIsLoading(true); // Start loading for API call

    try {
        // Call getScenarios with customer_id and scenario id to fetch the detail
        const response = await getScenarios({
            customer_id: customerId,
            scenario_id: value 
        });
        
        // Expected response is: {status: true, data: "scenario text"}
        if (response && response.status === true && response.data) {
            setMessage(response.data || response.data.scenario_text || ""); // Set the received text to the message
            setSelectedScenario(value);
//             const selectedScenariobj = scenarios. find (scenario => scenario.id === value);
// if (selectedScenarioobj) {
// setMessage (selectedScenario0bj.text);
// setSelectedScenario (value);
// // Focus the textarea after selecting a scenario
// inputRef. current. focus ();
        } else {
            console.error("Failed to fetch scenario text:", response);
            setMessage("");
            setSelectedScenario("");
        }
    } catch (error) {
        console.error("Error fetching scenario text:", error);
        setMessage("");
        setSelectedScenario("");
    } finally {
        setIsLoading(false); // End loading
        // Focus the textarea after selecting a scenario
        inputRef.current.focus();
    }
  };

  // Transform scenarios data to match SelectDropdown format
  const scenarioOptions = scenarios.map(scenario => ({
    value: scenario.id,
    label: scenario.scenario_name
  }));
  
  // Add an initial placeholder option
  scenarioOptions.unshift({ value: "", label: "Select Scenario" });

  return (
    <div className={classes.input_container}>
      <div className={classes.input_box}>
        <div className={classes.dropdown_container}>
          <SelectDropdown
            placeholder="Select Scenario"
            options={scenarioOptions}
            value={selectedScenario}
            onChange={handleSelectScenario}
            isLoading={isLoading}
            customStyles={{
              control: {
                width: "100%",
                zIndex: 40
              },
              menu: {
                width: "100%",
                zIndex: 40
              }
            }}
          />
        </div>

        <textarea
          ref={inputRef}
          className={classes.message_input}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Type a message"
        />
      </div>
      <button className={classes.send_btn} onClick={onSend} disabled={!message || loading}>
        <IoSend />
      </button>
    </div>
  );
}